<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <span>
          <el-button
            :disabled="isSaving"
            class="cancel-button"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >
            {{ $t('button.cancel') }}
          </el-button>
          <el-button
            :disabled="isLoading"
            :loading="isSaving"
            class="save-button"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </span>
      </div>
    </template>

    <el-form
      v-loading="isLoading"
      ref="form"
      :disabled="isSaving"
      :model="form"
      class="round-border-form"
      label-position="top"
      label-width="200"
    >
      <template v-for="(topBrand) in form.topBrands">
        <fieldset :key="topBrand.id">
          <legend>Top Brand</legend>
          <div class="form-group">
            <el-form-item label="Title">
              <el-input
                v-model="topBrand.title"
                clearable
              />
            </el-form-item>
          </div>
          <div class="form-group">
            <el-form-item label="Image Url">
              <el-input
                v-model.trim="topBrand.image"
                clearable
              />
            </el-form-item>
          </div>
          <div class="form-group">
            <el-form-item label="Link">
              <el-input
                v-model.trim="topBrand.link"
                clearable
              >
                <template slot="prepend">{{ goxipBaseUrl }}</template>
              </el-input>
            </el-form-item>
          </div>
        </fieldset>
      </template>
    </el-form>
  </sticky-header-layout>
</template>

<script>
import { getTrendingTopBrandDetail, updateTrendingTopBrand } from '../../api/trendings'

export default {
  name: 'TrendingTopBrandDetail',
  props: {
    slug: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        topBrands: [
          { title: '' },
          { image: '' },
          { link: '' },
        ],
      },
      isEdited: false,
      isLoading: false,
      isSaving: false,
    }
  },
  computed: {
    goxipBaseUrl() {
      return `${process.env.VUE_APP_GOXIP_BASE_URL}/`
    },
  },
  watch: {
    form: {
      handler() {
        this.isEdited = true
      },
      deep: true,
    },
  },
  mounted() {
    this.getTrendingTopBrand(this.slug)
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isSaving) {
      return next(false)
    }

    if (!this.isEdited) {
      return next()
    }

    try {
      await this.$confirm(this.$t('message.leaveWithUnsavedChanges'), this.$t('common.warning'), {
        confirmButtonText: this.$t('button.leave'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      })
      return next()
    } catch (error) {
      return next(false)
    }
  },
  methods: {
    async editTrendingTopBrand(form, slug) {
      this.isSaving = true
      try {
        await updateTrendingTopBrand(form.topBrands, slug)
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    async getTrendingTopBrand(slug) {
      this.isLoading = true
      try {
        const response = await getTrendingTopBrandDetail(slug)
        if (Array.isArray(response.data)) {
          this.form.topBrands = response.data
        }

        this.$nextTick(() => {
          this.isEdited = false
          this.isLoading = false
        })
      } catch (error) {
        this.isLoading = false
      }
    },
    handleSaveSuccess() {
      this.isSaving = false
      this.isEdited = false
      this.goToTrendingTopBrandList()
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
    handleValidate() {
      return this.form.topBrands.every(topBrand => !!(topBrand.title && topBrand.image && topBrand.link))
    },
    goToTrendingTopBrandList() {
      this.$router.push({ path: '/trending/top-brand-list' })
    },
    handleCancel() {
      this.goToTrendingTopBrandList()
    },
    handleSave() {
      if (this.handleValidate()) {
        this.editTrendingTopBrand(this.form, this.slug)
      } else {
        this.$alert(this.$t('error.pleaseFillInAndCheckErrors'), 'Oops..', {
          confirmButtonText: 'OK',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
@import "~@/assets/styles/form.scss";
</style>

<style lang="scss">
.el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>
